export const checklistKeys = {
    AV_PERMISSION: 'av_permission',
}
